// extracted by mini-css-extract-plugin
export default {"services":"Services_services__NHXr5","rowGray":"Services_rowGray__BNO29","rowWhite":"Services_rowWhite__rSWWb"};